import { useClientExtensionAdoptionRateStatQuery } from "@components/Stats/ClientExtensionAdoptionRateStat/ClientExtensionAdoptionRateStat.g";
import { useParams, Outlet, Navigate, useLocation } from "react-router";

import { routes } from "@pages/routes";

interface ExtensionInstallationGuardProps {
  children?: React.ReactNode;
}

export const ExtensionInstallationGuard = ({
  children,
}: ExtensionInstallationGuardProps) => {
  const { clientId } = useParams<{ clientId: string }>();
  const location = useLocation();

  const { data, isLoading } = useClientExtensionAdoptionRateStatQuery(
    { clientId: clientId! },
    { enabled: !!clientId },
  );

  if (!clientId || isLoading) {
    return null;
  }

  const users = data?.clientEmployees?.edges?.length ?? 0;
  let activeUsers = 0;

  data?.clientEmployees?.edges?.forEach((edge) => {
    if (edge?.node?.sessions?.totalCount && edge.node.sessions.totalCount > 0) {
      activeUsers += 1;
    }
  });

  const extensionRoute = routes.portal.clients.client.extension.$buildPath({
    params: { clientId },
  });

  if (users === 0 && activeUsers === 0) {
    if (location.pathname !== extensionRoute) {
      return <Navigate to={extensionRoute} replace />;
    }
  }

  return children ? <>{children}</> : <Outlet />;
};
